import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons";

import { ImageLetters } from "..";
import { ConditionIcon } from "../../../../components";
import { getImageAndVideoFileTypes, QUESTION_RESULT_STATUS, round2 } from "../../../../util/common";

import "./index.scss";

class NotFixedCheckItems extends Component {
  renderRow = (item, id, description, price, status) => {
    const { images } = getImageAndVideoFileTypes(item.attachments);

    return (
      <Grid.Row key={id} className="not-fixed-row">
        <Grid.Column width={13}>
          {item.title && (
            <span className="not-fixed-checks-title">
              <ConditionIcon status={status} />
              <ImageLetters images={images} lettersMap={this.props.lettersMap} />
              {item.title}
            </span>
          )}

          {description && (
            <div className="not-fixed-checks-profile-desc-container">
              <span className="not-fixed-checks-description">{description}</span>
            </div>
          )}
        </Grid.Column>
        <Grid.Column width={2} className="not-fixed-checks-price" textAlign="center">
          {price}
        </Grid.Column>
      </Grid.Row>
    );
  };

  renderPrice = price => {
    const { include_vat, vat } = this.props.settings;

    if (!(price > 0.01)) return null;

    if (include_vat) price = price * (1 + vat / 100);

    return <span className="not-fixed-price">€ {round2(price).toFixed(2)}</span>;
  };

  renderNotFixedItems = (interventions, customerOk) => {
    if (!Array.isArray(interventions)) return null;

    return interventions.filter(i => i.customer_ok === customerOk).map(i => this.renderRow(i, i.id, i.description, this.renderPrice(i.price), i.question_result_status));
  };

  render() {
    const { notFixedItems, t } = this.props;

    const customerApprovedNotFixedItems = this.renderNotFixedItems(notFixedItems, true);
    const customerNotApprovedNotFixedItems = this.renderNotFixedItems(notFixedItems, false);

    if (notFixedItems.length < 1) return null;

    return (
      <Grid verticalAlign="middle" className="report-v2-not-fixed-check-container component-container">
        <Grid.Row className="not-fixed-heading">
          <Grid.Column width={16}>
            <div className="not-fixed-heading-title-container">
              <div className="not-fixed-heading-title-sub-container">
                <FontAwesomeIcon icon={faTimesCircle} className="not-fixed-heading-icon" />
                <h2 className="not-fixed-heading-title">{t("cc_items_not_fixed").message || "Items not fixed"}</h2>
              </div>

              <div className="not-fixed-legend-container">
                <div className="not-fixed-heading-sub-status-item">
                  <ConditionIcon status={2} size="small" />
                  <span className="not-fixed-heading-sub-status-text">{t("cc_advisable").message || "Advisable"}</span>
                </div>
                <div className="not-fixed-heading-sub-status-item">
                  <ConditionIcon status={3} size="small" />
                  <span className="not-fixed-heading-sub-status-text">{t("cc_necessary").message || "Necessary"}</span>
                </div>
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>

        {customerApprovedNotFixedItems.length > 0 && (
          <>
            <Grid.Row className="not-fixed-heading-sub">
              <Grid.Column width={16}>
                <div className="not-fixed-heading-sub-text">
                  <h2>{t("cc_customer_approved").message || "Customer approved"}</h2>
                  {t("cc_not_fixed_will_be_repaired").message || "In agreement with you, items below will be repaired."}
                </div>
              </Grid.Column>
            </Grid.Row>
            {customerApprovedNotFixedItems}
          </>
        )}

        {customerNotApprovedNotFixedItems.length > 0 && (
          <>
            <Grid.Row className="not-fixed-heading-sub">
              <Grid.Column width={16}>
                <div className="not-fixed-heading-sub-text">
                  <h2>{t("cc_customer_not_approved").message || "Customer not approved"}</h2>
                  {t("cc_items_not_fixed_subtitle").message || "In agreement with you, the items below will not be repaired. Feel free to contact us."}
                </div>
              </Grid.Column>
            </Grid.Row>
            {customerNotApprovedNotFixedItems}
          </>
        )}
      </Grid>
    );
  }
}

const TranslatedNotFixedCheckItems = withTranslation()(NotFixedCheckItems);

TranslatedNotFixedCheckItems.filterNotFixedItems = results => {
  return results.filter(
    r =>
      (!r.question_result_id || r.question_result_status === QUESTION_RESULT_STATUS.ADVISED || r.question_result_status === QUESTION_RESULT_STATUS.NECESSARY) &&
      !r.mechanic_fixed
  );
};

export default TranslatedNotFixedCheckItems;
